module.exports = __webpack_public_path__ + "static/media/utrip.c1599709.png";